// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__yiOKS","text":"SelectPayment_text__31sDl","title":"SelectPayment_title__1-VHD","btn":"SelectPayment_btn__2YrRE"};